/**
 * 病案管理工作站路由。
 *
 * @module clinical-record/front-sheet
 */
import type { RouteRecordRaw } from "vue-router";

export const frontSheetRoutes: RouteRecordRaw[] = [
  {
    path: "/front-sheet",
    name: "FrontSheetStation",
    component: () => import("./interfaces/FrontSheetStationView.vue"),
    meta: {
      title: "病案管理工作站",
      requiresAuth: true,
      keepAlive: false,
      breadcrumb: ["病案管理工作站"],
    },
  },
];

export default frontSheetRoutes;
